import { Component, inject } from '@angular/core';
import { InputFieldComponent } from '@zayan-erp/shared';
import { BuilderReferenceService } from '../../services/builder-reference.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { DynamicRouteHandlingService } from 'libs/shared/src/lib/services/dynamic-route-handling.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BuilderReferenceRequest } from '../../models/builder-reference.models';

@Component({
  selector: 'lib-builder-reference-form',
  imports: [InputFieldComponent, ReactiveFormsModule],
  templateUrl: './builder-reference-form.component.html'
})
export class BuilderReferenceFormComponent {
  #builderReferenceService = inject(BuilderReferenceService);
  #activatedRoute = inject(ActivatedRoute);
  #dynamicRouteHandling = inject(DynamicRouteHandlingService);
  #router = inject(Router);
  from = new FormGroup({
    reference: new FormControl<string | null>(null, Validators.required)
  });
  selectedReferenceId: string | null = null;

  constructor() {
    this.selectedReferenceId = this.#activatedRoute.snapshot.params['id'];
    if (this.selectedReferenceId) {
      this.#builderReferenceService.getBuilderReferenceById(this.selectedReferenceId).subscribe(builderReference => {
        this.from.patchValue({
          reference: builderReference?.reference
        });
      });
    }

    this.#dynamicRouteHandling.submitButton.pipe(takeUntilDestroyed()).subscribe(() => this.submit());
  }

  submit() {
    if (this.from.invalid) {
      this.from.markAllAsTouched();
      return;
    }

    const formData = this.from.value;
    if (!this.selectedReferenceId) {
      this.#builderReferenceService.createBuilderReference(formData as string).subscribe({
        next: () => this.onFormSuccessfulSubmit()
      });
    } else {
      let reference: BuilderReferenceRequest = {
        id: this.selectedReferenceId,
        reference: formData.reference ?? ''
      };
      this.#builderReferenceService.updateBuilderReference(reference).subscribe({
        next: () => this.onFormSuccessfulSubmit()
      });
    }
  }

  onFormSuccessfulSubmit() {
    this.#dynamicRouteHandling.reload.next(!this.#dynamicRouteHandling.reload.value);
    this.#router.navigate(['/home-building/builder-reference']);
    this.from.reset();
  }
}
